import { useState } from "react";
import { ChevronRight } from "lucide-react";
import { http, notify, errorMessage } from "../api";

export default function Login({ onLogin }) {
  // The `identifier` input accepts an Employee ID (all admin-created accounts)
  // OR an email (legacy admin accounts seeded before the pivot). We detect
  // the two by presence of "@".
  const [identifier, setIdentifier] = useState("admin@dsaconnect.test");
  const [password, setPassword] = useState("LoanCRM2026!");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const isEmail = identifier.includes("@");
      const body = isEmail
        ? { email: identifier, password }
        : { employee_code: identifier.trim().toUpperCase(), password };
      const r = await http.post("/auth/login", body);
      notify.success(`Welcome back, ${r.data.name?.split(" ")[0]}`);
      onLogin(r.data);
    } catch (err) {
      const message = errorMessage(err) || "Unable to sign in";
      setError(message);
      notify.error(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="login-page">
      <div className="login-aside">
        <div className="brand-mark">RX</div>
        <p className="eyebrow">RUPEE XPERT / OPERATIONS</p>
        <h1>
          Every lead,
          <br />
          <em>accountable.</em>
        </h1>
        <p className="login-copy">
          A focused workspace for loan distribution teams — from first conversation to disbursement.
        </p>
        <div className="login-rule" />
        <p className="mono">PARTNER BANKS · HUMAN WORKFLOWS · CLEAR OWNERSHIP</p>
      </div>
      <form className="login-form" onSubmit={submit}>
        <div>
          <p className="eyebrow">SECURE ACCESS</p>
          <h2>Welcome back</h2>
          <p className="muted">Sign in with your Employee ID.</p>
        </div>
        <label>
          Employee ID
          <input
            data-testid="login-form-identifier-input"
            value={identifier}
            onChange={(e) => setIdentifier(e.target.value)}
            required
            autoComplete="username"
            placeholder="e.g. RXSA00125"
          />
        </label>
        <label>
          Password
          <input
            data-testid="login-form-password-input"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            type="password"
            required
            autoComplete="current-password"
          />
        </label>
        {error && (
          <div data-testid="login-error-message" className="error">
            {error}
          </div>
        )}
        <button
          data-testid="login-form-submit-button"
          className="primary-button"
          type="submit"
          disabled={loading}
        >
          {loading ? "Signing you in…" : "Enter workspace"} <ChevronRight size={17} />
        </button>
        <p className="login-note">Legacy admin emails still work · new users sign in with their Employee ID.</p>
        <a
          href="/register"
          data-testid="login-register-link"
          className="login-note"
          style={{ display: "block", textAlign: "center", marginTop: 8, color: "var(--red)", fontWeight: 600 }}
        >
          New Sales Associate? Register here →
        </a>
        <a
          href="/register#check"
          data-testid="login-check-status-link"
          className="login-note"
          style={{ display: "block", textAlign: "center", marginTop: 4, fontSize: 11 }}
          onClick={() => { sessionStorage.setItem("reg_mode", "check"); }}
        >
          Registration in review? Check status
        </a>
      </form>
    </main>
  );
}
